import { NavLink, Outlet } from "react-router-dom";
import { PageHeader } from "@/components/dash/ui";

const ADMIN_TABS = [
  { label: "Users", to: "/admin" },
  { label: "Companies", to: "/admin/companies" },
  { label: "Branches", to: "/admin/branches" },
  { label: "Locations", to: "/admin/locations" },
  { label: "Employees", to: "/admin/employees" },
  { label: "Mappings", to: "/admin/mappings" },
  { label: "Reporting", to: "/admin/reporting" },
];

export default function AdminLayout() {
  return (
    <div className="space-y-6">
      <PageHeader title="Admin & Settings" description="Master data, source-entity mappings and access control." />
      <nav className="flex flex-wrap gap-1 border-b border-ink-500/60 text-sm">
        {ADMIN_TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.to === "/admin"}
            className={({ isActive }) =>
              `-mb-px border-b-2 px-3 py-2 ${
                isActive
                  ? "border-brand-400 text-white"
                  : "border-transparent text-slate-400 hover:text-slate-200"
              }`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <div className="panel panel-pad">
        <Outlet />
      </div>
    </div>
  );
}
